<template>
    <div></div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator";

    @Component({})
    export default class Guide extends Vue {
        mounted() {
            this.initForeignCustomerService();
        }

        initForeignCustomerService() {
            if (this.internal) return;
            const script = document.createElement("script");
            script.src = "https://crm-static.wondershare.cc/chatbot/latest/assets/snippet.js?key=83e95267-c410-e755-b33f-cd4f074ce1b2";
            script.id = "ws-snippet";
            window["___crm40_hide_chatbot_bubble_mode___"] = true;
            document.body.appendChild(script);
        }
    }
</script>
